<!-- Hero banner6: fondo.png de fondo, la persona a la izquierda pegada
     al piso y los tres textos apilados y centrados a la derecha -->
<section class="hero-banner6">
    <div class="container">
        <div class="row">

            <!-- Izquierda: la persona, al ras del borde de abajo -->
            <div class="col-12 col-md-6 hero6-col-persona">
                <img src="/assets/images/sorteo2026/banner6/persona.png" class="hero6-persona"
                    alt="2° Sorteo Oportuno Anáhuac">
            </div>

            <!-- Derecha: los tres textos, centrados en los dos ejes -->
            <div class="col-12 col-md-6 hero6-col-textos" data-aos="zoom-in">
                <img src="/assets/images/sorteo2026/banner6/sorteo.png" class="hero6-sorteo" alt="Sorteo Anáhuac">
                <img src="/assets/images/sorteo2026/banner6/2sorteo.png" class="hero6-2sorteo" alt="2° Sorteo Oportuno">
                <img src="/assets/images/sorteo2026/banner6/21agosto.png" class="hero6-fecha" alt="21 de agosto">
            </div>

        </div>
    </div>
</section>

<br><br>
<section class="stc-winners-opt so2">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 class="titulo-oficial">
                    LISTA DE PARTICIPANTES
                    <span class="d-block">
                        2° SORTEO OPORTUNO 2026
                    </span>
                </h2>
            </div>

            <!-- Lista que se arma con el Excel. Mismo bloque que usan las
                 demas listas de participantes (participantessorteopt,
                 participantes-egresados, -lealtad, -amigo, -son): buscador
                 arriba, tabla .table-striped .table-hover con los colores
                 que pone .stc-winners-opt en el sass global, y al final los
                 pagination-controls. El overflow-x deja que la tabla se
                 desplace sola en pantallas chicas en vez de romper el ancho
                 del container. -->
            <div class="col-md-12">
                <div class="text-center" style="overflow-x: auto;">
                    <label for="search" class="mt-5"
                        style="text-align: left !important; width: 100%; font-weight: 600; font-size: 18px;">Buscar:</label>
                    <input id="search" type="text" class="form-control mb-3" placeholder="Ingresa nombre o folio"
                        [(ngModel)]="searchText" (input)="filterData()" />

                    <table class="table table-striped table-hover mt-3">
                        <thead>
                            <tr class="cols">
                                <th scope="col" style="width: 30%;"><span>FOLIO</span></th>
                                <th scope="col" style="width: 70%;"><span>NOMBRE</span></th>
                            </tr>
                        </thead>
                        <tbody class="text-center">
                            <tr
                                *ngFor="let participante of filteredData | paginate: { itemsPerPage: 50, currentPage: p }">
                                <td class="text-center align-middle" style="width: 30%;">
                                    <strong>{{ participante.folio }}</strong>
                                </td>

                                <!-- El nombre va completo y en mayusculas por CSS, no por
                                     codigo, igual que en las demas listas. Si SEGOB pide
                                     abreviar los apellidos, el componente ya trae
                                     getInitials() listo para envolver este valor. -->
                                <td class="text-center align-middle text-uppercase" style="width: 70%;">
                                    {{ participante.nombre || 'FISICO' }}
                                </td>
                            </tr>

                            <tr *ngIf="filteredData.length === 0">
                                <td colspan="2" class="text-center text-muted py-4 align-middle">
                                    No se encontraron datos.
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <pagination-controls (pageChange)="p = $event" previousLabel="Anterior" nextLabel="Siguiente">
                    </pagination-controls>
                </div>
            </div>


            <div class="col-12 mt-5 pt-0 footer-egr">
                <p class="font-bold">
                    SORTEO ANÁHUAC MAGNO
                </p>
                <p class="font-bold">
                    SEGUNDO SORTEO OPORTUNO
                </p>

                <p class="font-bold">
                    ENTREGA DE PREMIOS:

                </p>
                <p>

                    Los premios mayores a 1,500 (UMA) $175,965.00 (Ciento setenta y cinco mil novecientos sesenta y
                    cinco pesos 00/100 m.n.) se solicitará la presencia de un inspector de la DGJS para la entrega de
                    estos, conforme al siguiente calendario de fechas: 04 de septiembre de 2026 a las 12:00 horas,
                    entrega del Premio 1 de comprador, del Primer Sorteo Acumulado Especial de Compradores y
                    Colaboradores Oportunos del SORTEO ANÁHUAC MAGNO. En las instalaciones de la Universidad Anáhuac
                    México Campus Norte con domicilio en Av. Universidad Anáhuac no. 46 Huixquilucan, Estado de México.
                    C.P. 52786.
                </p>
              
                <p>Las personas que resulten ganadoras deberán presentar una identificación oficial vigente con
                    fotografía (credencial INE, pasaporte), comprobante de domicilio (no mayor a tres meses), Constancia
                    de situación fiscal (mes en curso) y CURP; el nombre completo escrito en el boleto debe corresponder
                    exactamente con el del talón o con el registro en la APP del Sorteo Anáhuac y su identificación
                    oficial.</p>
                <p>En caso de queja derivada de este sorteo, la autoridad competente es la Dirección General de Juegos y
                    Sorteos de la Secretaría de Gobernación ubicada en la calle de Versalles 49, piso 2, Col. Juárez,
                    Del. Cuauhtémoc, C.P. 06600, Ciudad de México o bien comunicarse al teléfono: 01(55) 5209 8800.</p>
                <p>Para más información sobre dónde reclamar la entrega de los premios, documentos necesarios para
                    recibirlos diríjase a: www.sorteoanahuac.mx, o a la oficina del Sorteo Anáhuac, A.C. ubicada en la
                    calle “Av. Universidad Anáhuac no. 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de
                    México o al teléfono: 01(55) 5328-8096 ext 2137.</p>
                <p><strong>PERMISO SEGOB: 20260061PS09</strong></p>

            </div>

        </div>
    </div>
</section>